import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"
import StarsHome from "./StarsHome"
import styled from "@emotion/styled"
import { breakpoints, color, ContentStyles } from "../../../utils/style"

const WhyUsWrap = styled("div")`
  .title-block {
    margin: 8rem 0 1rem;
    position: relative;
  }
  h2 {
    font-size: 43px;
    line-height: 1.3;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
  }

  @media (max-width: ${breakpoints.md}) {
    h2 {
      font-size: 22px;
    }
  }  
`

const SlidesList = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px auto;
  
  .slide-item {
    flex-basis: 49.2%;
    background: ${color.transparentWhite1};
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 20px;
    display: flex;
    flex-flow: row-wrap;
    align-items: center;
    .img-wrap {
      width: 95px;
    }
    
    .text-wrap {
      flex: 1;
      padding: 0 0 0 20px;
      font-size: 14px;
    }
    
    @media (max-width: ${breakpoints.md}) {
      flex-basis: 100%;
    }  
  }
`;

const ContentWrapperSimple = styled("div")`
  margin-bottom: 40px;
  ${ContentStyles}
`;

const WhyUs = ({ h2, slides, text }) => {

  return (
    <WhyUsWrap>
      {h2 && <div className="title-block">
        <h2 className="h3">{h2}</h2>
        <StarsHome />
      </div>}
      {text && <ContentWrapperSimple dangerouslySetInnerHTML={{ __html: text }}/>}
      {slides.length > 0 && (
        <SlidesList>
          {slides.map(item => (
            <div key={item.id} className="slide-item">
              {item?.localFile?.childImageSharp?.fluid && (
                <div className="img-wrap">
                  <Img
                    fluid={item.localFile.childImageSharp.fluid}
                    alt={item.altText ? item.altText : "Golden Slot"}
                    fadeIn={false}
                    loading="eager"
                  />
                </div>
              )}
              {item.acf?.slide_description &&
              <div className="text-wrap"
                   dangerouslySetInnerHTML={{ __html: item.acf.slide_description }} />
              }
            </div>
          ))}
        </SlidesList>
      )}
    </WhyUsWrap>
  )
}

export default WhyUs

WhyUs.propTypes = {
  h2: PropTypes.string,
  text: PropTypes.string,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      acf: PropTypes.shape({
        slide_description: PropTypes.string,
        slide_title: PropTypes.string,
        slide_url: PropTypes.string
      }),
      alt_text: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string
    })
  )
}
